module.exports = ".box-body {\n  background-color: #f0f0f0; }\n\np {\n  font-size: 16px; }\n"